import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import PublicLayout from "@/components/public/PublicLayout";
import Home from "@/pages/Home";
import TripDetail from "@/pages/TripDetail";
import Jadwal from "@/pages/Jadwal";
import CekPesanan from "@/pages/CekPesanan";
import OrderDetail from "@/pages/OrderDetail";
import { AdminRoot } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/admin/ui";
import AdminLayout from "@/components/admin/AdminLayout";
import AdminLogin from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import Orders from "@/pages/admin/Orders";
import Schedule from "@/pages/admin/Schedule";
import Trips from "@/pages/admin/Trips";
import Finance from "@/pages/admin/Finance";
import Settings from "@/pages/admin/Settings";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/trip/:id" element={<TripDetail />} />
          <Route path="/jadwal" element={<Jadwal />} />
          <Route path="/cek-pesanan" element={<CekPesanan />} />
          <Route path="/pesanan/:code" element={<OrderDetail />} />
        </Route>
        <Route path="/admin" element={<AdminRoot />}>
          <Route path="login" element={<AdminLogin />} />
          <Route element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="pesanan" element={<Orders />} />
            <Route path="jadwal" element={<Schedule />} />
            <Route path="trip" element={<Trips />} />
            <Route path="keuangan" element={<Finance />} />
            <Route path="pengaturan" element={<Settings />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster theme="dark" position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
